






















import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { Size } from "../../../../domain/drawing";
import { Section } from "../../../../domain/document";

@Component
export default class PageSilhouetteIndicator extends Mixins() {
  @Prop()
  size: Size;

  @Prop()
  section: Section;

  @Prop()
  isFocused: boolean;

  @Prop()
  pageNumber: number;

  @Emit()
  click() {}

  get rectangleProperties(): any {
    return {
      width: this.size.width + "px",
      height: this.size.height  + "px",
    };
  }

  get scale(): number {
    return (this.isValid(this.size) && this.isValid(this.pageSize))
      ? Math.min(this.size.width / this.pageSize.width, this.size.height / this.pageSize.height)
      : 1.0;
  }

  isValid(source: Size): boolean {
    return (0 < source.width)
        && (0 < source.height);
  }

  get scaledSizeStyle(): any {
    return {
      width: this.scaledSize.width + "px",
      height: this.scaledSize.height + "px",
    };
  }

  get scaledSize(): Size {
    return new Size(
      Math.floor(this.pageSize.width * this.scale),
      Math.floor(this.pageSize.height * this.scale));
  }

  get pageSize(): Size {
    return this.section
      ? this.section.size
      : new Size(0, 0);
  }

  get thumbnailImageSource(): any {
    return !this.section
      ? ""
      : this.section.thumbnailImageSource.source;
  }

  get thumbnailImageWidth(): number {
    return this.scaledSize.width;
  }

  get thumbnailImageHeight(): number {
    return this.scaledSize.height;
  }

  get indicatorStyleProperties(): any {
    return {
      borderWidth: (this.isFocused ? 1 : 0) + "px",
    };
  }
}
